<template>
  <div class="text-center mt-2">
    <h5 class="mb-4">No Web3 Wallet</h5>
    <p>Create or import a wallet to start collecting tokens.</p>
    <img src="../assets/images/onboarding-welcome-decentralised-apps.svg" alt="">
    <div>
        <button @click="toCreateWallet" class="btn btn-primary">Create a new wallet</button>
    </div>
    <div class="mt-3 mb-3">
        <button @click="toImportWallet" class="btn btn-primary">Import an existing wallet</button>
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router'
export default {
  setup () {
    const router = useRouter()
    const toCreateWallet = () => {
      router.push({ name: 'patient.createWallet' })
    }

    const toImportWallet = () => {
      router.push({ name: 'patient.importWallet' })
    }

    return {
      toCreateWallet,
      toImportWallet
    }
  }
}
</script>

<style scoped>
.btn {
    width: 200px;
}
</style>
